module.exports = __webpack_public_path__ + "img/hx-kcgl.a9ac61ff.svg";